import React from 'react';
import PropTypes from 'prop-types';
import Image from 'next/image';
import CustomButton from '@components/Button/Button';
import { useRouter } from 'next/router';

export default function PaymentSuccess({
  planName,
  handleAddMemberModalOpen,
  setUpdateSeatModal,
  selectedTeam,
}) {
  const router = useRouter();
  const handleNavigation = () => router.push('/transaction');
  const handleClick = () => {
    setUpdateSeatModal(false);
    handleAddMemberModalOpen();
  };
  return (
    <div>
      <div className='text-center'>
        <div className='flex justify-center'>
          <Image
            width='96px'
            height='96px'
            alt='alert'
            src='/assets/restart.svg'
          />
        </div>
        <div className='font-bold text-[20px] pt-5 dark:text-white'>
          Congratulations!
        </div>
        <div className='dark:text-white pt-3'>
          <span className='text-sm'>
            Your card was successfully charged and additional user seat(s) have
            been added to your
            <b className='text-secondary-blue'> {planName}</b> plan
          </span>
        </div>
        <div className='lg:flex md:flex sm:block xs:block justify-center items-center pt-3 pb-3'>
          {selectedTeam?.role === 'owner' ? (
            <>
              <CustomButton
                fullWidth
                btnColor='blue'
                onClick={handleNavigation}
              >
                View Invoice
              </CustomButton>
              <div className='px-3 '>or</div>
            </>
          ) : null}
          <CustomButton fullWidth btnColor='blue' onClick={handleClick}>
            Add Members
          </CustomButton>
        </div>
      </div>
    </div>
  );
}
PaymentSuccess.propTypes = {
  planName: PropTypes.string,
  handleAddMemberModalOpen: PropTypes.func,
  setUpdateSeatModal: PropTypes.func,
  selectedTeam: PropTypes.object,
};
